import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  FileCheck2,
  Wallet,
  Landmark,
  Code2,
  Scale,
  Users,
  Shield,
  Smartphone,
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useEnvironment } from '../../context/EnvironmentContext';
import { canAccess, type NavId } from '../../utils/roles';

const NAV: { id: NavId; to: string; label: string; icon: typeof LayoutDashboard }[] = [
  { id: 'dashboard', to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'kyb', to: '/kyb', label: 'KYB Onboarding', icon: FileCheck2 },
  { id: 'settlement', to: '/settlement', label: 'Settlement wallet', icon: Wallet },
  { id: 'payouts', to: '/payouts', label: 'Payouts', icon: Landmark },
  { id: 'developer', to: '/developer', label: 'Developer Hub', icon: Code2 },
  { id: 'terminals', to: '/terminals', label: 'POS Terminals', icon: Smartphone },
  { id: 'disputes', to: '/disputes', label: 'Disputes', icon: Scale },
  { id: 'team', to: '/team', label: 'Team', icon: Users },
  { id: 'security', to: '/security', label: 'Security & 2FA', icon: Shield },
];

export function Sidebar() {
  const { user } = useAuth();
  const { isSandbox, accentClass } = useEnvironment();
  const role = user?.role ?? 'owner';

  return (
    <aside className="w-64 shrink-0 border-r border-onyx-border bg-onyx-surface/50 flex flex-col min-h-screen">
      <div className="p-6 border-b border-onyx-border">
        <p className="font-display text-2xl tracking-wide text-onyx-text">Onyx Pay</p>
        <p className={`text-xs mt-1 ${accentClass}`}>Merchant Portal</p>
        <p className="text-[10px] uppercase tracking-widest text-onyx-muted mt-2">
          {isSandbox ? 'Test environment' : 'Production'}
        </p>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {NAV.filter((n) => canAccess(role, n.id)).map(({ id, to, label, icon: Icon }) => (
          <NavLink
            key={id}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm transition ${
                isActive
                  ? isSandbox
                    ? 'bg-onyx-purple/15 text-onyx-purple'
                    : 'bg-onyx-gold/15 text-onyx-gold'
                  : 'text-onyx-muted hover:text-onyx-text hover:bg-onyx-elevated'
              }`
            }
          >
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
